import React, { useState, useEffect, useCallback, useMemo } from 'react';
import './App.scss';
import Content from './Content';

import useWindowDimensions from './utils/useWindowDimensions';
import axios from './axios-instance';
import { BrowserRouter as Router, Route, Switch, withRouter, useHistory} from 'react-router-dom';
import Wallet from './components/Wallet/Wallet';
import Stats from './components/Stats/Stats';
import Error from './components/UI/Error/Error';
import ReactGA from 'react-ga4';
import { withCookies, useCookies } from 'react-cookie';
import { v4 as uuidv4 } from 'uuid';
import { useSelector, useDispatch } from 'react-redux';
import { updateDeviceDetails } from './store/deviceSlice';
import { mobileCheck } from './utils/mobileCheck';
import Logo from './components/UI/Logo/Logo';
import Footer from './components/UI/Footer/Footer';
import MetaTags from 'react-meta-tags';
import { getCdnPath } from './utils/helpers';
import FrequentlyAskedQuestions from './components/FrequentlyAskedQuestions/FrequentlyAskedQuestions';
import createOrLoginHero from './images/login-create-account-hero.png';
import Info from './components/Info/Info';

const App = (props) => {
    
    const { location, ua } = props;
    const [
        cookies,
        setCookie,
        // removeCookie
    ] = useCookies(['A8FPVID', 'A8CFVLH', 'A8APPID']); 
    let history = useHistory(); 

    const deviceSelector = useSelector((state) => state.device);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [timedOut, setTimedOut] = useState(false);
    const [
        ,
        // totalLoadTime
        setTotalLoadTime,
    ] = useState(null);
    const [error, setShowError] = useState({
        showError: false,
        errorCode: null,
        title : null,
        description : null
    });
    const [initialLoadTime, setInitialLoadTime] = useState(null);
    const [hasSlug, setHasSlug] = useState(null);
    const [catchUrlSearch, setCatchUrlSearch] = useState(null);
    const [gdpr, setGdpr] = useState(null);
    const [gdprConsent, setGdprConsent] = useState(null);
    const [forwardParams, setForwardParams] = useState(null);
    const [geolocationEnabled, setGeolocationEnabled] = useState(false);
    const [
        ,
        // fetchLocation
        setFetchLocation,
    ] = useState(null);
    const [showWallet, setShowWallet] = useState(false);

    const [showActv8, setShowActv8] = useState(false);
    const [timestamp, setTimestamp] = useState(null);

    const getWindowDimensions = () => {
        let div = document.getElementById('responsiveContentContainer');    
        if (div) {
            let w = div.offsetWidth;
            let h = div.offsetHeight
            return {
                w,
                h
            };
        }
    }
    //const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const { height, width } = useWindowDimensions();

    const deviceDetails = useMemo(() => {
        const deviceToUpdate = {};

        deviceToUpdate.uuid = cookies.A8FPVID;
        deviceToUpdate.a8GeoIp = cookies.A8CFVLH;
        deviceToUpdate.os_name = ua?.os?.name;
        deviceToUpdate.os_version = ua?.os?.version;
        deviceToUpdate.manufacturer = ua?.device?.vendor;
        deviceToUpdate.model = ua?.device?.model;
        deviceToUpdate.locale = navigator?.language ?? 'en-us';
        deviceToUpdate.isMobile = mobileCheck();
        deviceToUpdate.isIphone =
            navigator?.userAgent?.toLowerCase()?.indexOf('iphone') > -1;

        return deviceToUpdate;
    }, [cookies.A8FPVID, cookies.A8CFVLH, ua]);
    
    const params = new URLSearchParams(location.search);

    const setGoogleAnalytics = () => {
        if (
            process.env.REACT_APP_GOOGLE_ANALYTICS_PROPERTY_ID !== undefined &&
            process.env.REACT_APP_GOOGLE_ANALYTICS_PROPERTY_ID !== null
        ) {
            ReactGA.initialize(
                process.env.REACT_APP_GOOGLE_ANALYTICS_PROPERTY_ID
            );
            ReactGA.send('pageview');
        }
    }

    const setPageLoadObserver = () => {
        setInitialLoadTime(Date.now());

        const timeOutValue =
            process.env.REACT_APP_TIMEOUT_VALUE !== undefined &&
            process.env.REACT_APP_TIMEOUT_VALUE !== null
                ? process.env.REACT_APP_TIMEOUT_VALUE
                : 15000;
        setTimeout(() => {
            if (initialLoadTime !== null && loading && timedOut === false) {
                setTimedOut(true);
                setTotalLoadTime(Date.now() - initialLoadTime);
            }
        }, timeOutValue);
    }

    const getUuid = () => {
        console.log('Getting UUID...');   

        const uuid = btoa(uuidv4());
        
        const cookieMaxAge = process.env
            .REACT_APP_COOKIE_A8FPVID_EXPIRATION
            ? process.env.REACT_APP_COOKIE_A8FPVID_EXPIRATION *
                (60 * 60 * 24)
            : (60 * 60 * 24); // (60 seconds * 60 minutes * 24 hours)

        setCookie('A8FPVID', uuid, {
            maxAge: cookieMaxAge,
            path: '/',
            domain: process.env.REACT_APP_COOKIE_DOMAIN
        });

        return uuid;

    }

    const getSl = async () => {

        axios.get(
            `/shortlink?slug=${params.get('sl')}`
        ).then((res)=>{
            if (res && res.data) {
                console.log('Long url is' + res.data.url);
                let search = new URL(res.data.url).search;
                setCatchUrlSearch(search);
            } else {
                setShowError({
                    showError: true,
                    errorCode: 404,
                });
                setLoading(false);
            }
        }).catch((err)=>{
            setShowError({
                showError: true,
                errorCode: 404,
            });
            setLoading(false);
        }).finally();
    };

    const extractForwardParams = () => {
        params.delete('sl');
        params.delete('geolocation');
        // Set forward params with non-actv8 params
        setForwardParams(params.toString());
    };

    const checkSlug = () => {
        console.log('Checking slug...');
        let locationEnabled = false;
        params.forEach((value, key) => {
            if (key === 'geolocation' && value === 'true') {
                locationEnabled = true;
            }
        });
        setGeolocationEnabled(locationEnabled);
        if (params.has('gdpr') && params.has('gdpr_consent')) {
            setGdpr(params.get('gdpr'));
            setGdprConsent(params.get('gdpr_consent'));
        }
        if (params.has('ts')) {
            setTimestamp(parseInt(params.get('ts')));
        }
        if (params.has('sl')) {
            setHasSlug(true);
            getSl(params);
        } else {
            setHasSlug(false);
        }
        extractForwardParams();
    };

    const checkParams = () => {
        console.log('checking  params...');
        const paramsString = window.location.search;
        const params = new URLSearchParams(paramsString);
        if (
            !params.has('sl') &&
            (!params.has('triggerable_id') || !params.has('client_id'))
        ) {
            setShowWallet(true);
        } else {
            setShowWallet(false);
        }
    };

    const registerDevice = useCallback(
        () => {
            const device = deviceDetails;

            !loading && setLoading(true);
            if (!deviceSelector?.deviceDetails?.id) {
                let endpoint = `device/`;
                if (gdpr) {
                    endpoint += `?gdpr=${gdpr}`;
                    endpoint += `&gdpr_consent=${gdprConsent}`;
                }

                axios.post(endpoint, device, {
                    headers: {
                        'x-device-uuid': `${device.uuid}`,
                    },
                }).then((res)=>{
                    if (res && res.data) {
                        const deviceToUpdate = {
                            ...res?.data,
                            isMobile: deviceDetails?.isMobile,
                            isIphone: deviceDetails?.isIphone,
                        };
                        dispatch(updateDeviceDetails(deviceToUpdate));
                        checkParams();
                    }
                }).catch((err)=>{
                    if (err.message === 'Request failed with status code 403') {
                        setShowError({
                            showError: true,
                            errorCode: 403,
                        });
                        setLoading(false);
                    } else {
                        setShowError({
                            showError: true,
                            errorCode: err.status,
                        });
                        setLoading(false);
                    }
                    console.error('ERROR: ', err.message);
                }).finally();

            }
        },
        [
            loading,
            deviceSelector?.deviceDetails?.id,
            gdpr,
            gdprConsent,
            deviceDetails?.isMobile,
            deviceDetails?.isIphone,
            dispatch,
        ]
    );

    const getLocation = useCallback(
        (device) => {
            if (!('geolocation' in navigator)) {
                console.log('geolocation not available');
                registerDevice(device);
                return;
            }
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    device.latitude = position.coords.latitude;
                    device.longitude = position.coords.longitude;
                    setFetchLocation(position);
                    setLoading(false);
                    registerDevice(device);
                },
                (err) => {
                    console.log(err);
                    setFetchLocation(null);
                    setLoading(false);
                    registerDevice(device);
                }
                //{timeout: 7000}
            );
        },
        [registerDevice]
    );

    // useEffect(() => {
    //     function handleResize() {
    //         setWindowDimensions(getWindowDimensions());
    //     }
    //     window.addEventListener('resize', handleResize);
    //     return () => window.removeEventListener('resize', handleResize);
    // }, []);

    useEffect(() => {

        const { cookieEnabled } = navigator;
        console.log('Cookie enabled : ' + cookieEnabled);

        if(!cookieEnabled) {
            setShowError({
                showError: true,
                errorCode: 'Cookies disabled',
                title: null,
                description: 'This site requires cookies to be enabled. Please enable them and try again.',
            });
            setLoading(false);
            return;
        }

        // Sets google analytics
        setGoogleAnalytics();
        
        // Sets timers 
        setPageLoadObserver();
        
        // VCheck slug
        checkSlug();
        
        // Get device uuid
        if (!deviceDetails?.uuid || deviceDetails?.uuid === '') {
            deviceDetails.uuid = getUuid();
        } else {
            console.log('UUID retrieved from ck');
        }

        // Register device
        registerDevice(deviceDetails);
        // geolocationEnabled ? getLocation(deviceDetails) : registerDevice(deviceDetails);
        // eslint-disable-next-line react-hooks/exhaustive-deps

    }, []);


    return (

        <div id="appContainer" style={{ 
            backgroundImage: `url(${getCdnPath(process.env.REACT_APP_BACKGROUND_URL)})`, 
            height: height, 
            overflowY: "scroll", 
            paddingBottom: "40px", 
            textAlign:"center", 
            backgroundRepeat: "no-repeat", 
            backgroundSize: "cover", 
            backgroundAttachment: "fixed",
            minWidth:"360px"
        }}>
        <MetaTags>
            <title>{process.env.REACT_APP_META_TITLE}</title>
            <meta name="description" content={process.env.REACT_APP_META_DESCRIPTION} />
            <meta property="og:title" content={process.env.REACT_APP_META_TITLE} />
            <meta property="og:site_name" content={process.env.REACT_APP_META_SITE_NAME}/>
            <meta property="og:description" content={process.env.REACT_APP_META_DESCRIPTION} />
        </MetaTags>
        <Router>
            <Switch>
                {process.env.REACT_APP_WALLET_ENABLED && 
                    <Route path="/wallet">
                        <Logo />                    
                        <Wallet device={deviceSelector.deviceDetails} />
                        <Footer />
                    </Route>
                }
                <Route path="/redirect">
                    <Logo />
                    <div style={{
                        height: "auto",
                        left: 0,
                        bottom: 0,
                        backgroundColor: "#fff",
                        boxSizing: "border-box",
                        transition: "transform 0.3s ease-out",
                        color: "black", 
                        width: "88%", 
                        marginLeft: "auto", 
                        marginRight: "auto", 
                        display: "block",
                        borderRadius: "8px",
                        padding: "20px",
                        fontFamily : process.env.REACT_APP_BODY_STYLE_FONT_FAMILY                        
                    }}>
                        <h1 style={{fontSize : "28px", marginBottom: "35px"}}>You've been redirected</h1>
                        <p>Thank you for visiting our site.</p>
                    </div>
                    <Footer />
                </Route>
                <Route path="/error">
                    <Logo />
                    <div style={{
                        height: "auto",
                        left: 0,
                        bottom: 0,
                        backgroundColor: "#fff",
                        boxSizing: "border-box",
                        transition: "transform 0.3s ease-out",
                        color: "black", 
                        width: "88%", 
                        marginLeft: "auto", 
                        marginRight: "auto", 
                        display: "block",
                        borderRadius: "8px",
                        padding: "20px",
                        fontFamily : process.env.REACT_APP_BODY_STYLE_FONT_FAMILY                        
                    }}>
                        <h1 style={{fontSize : "28px", marginBottom: "35px"}}>Sorry, Something Went Wrong</h1>
                        <p>Looks like something went wrong trying to load this webpage. Please try again.</p>
                        <p><strong>Error code: {params.get('code')}</strong></p>
                    </div>
                    <Footer />
                </Route>                
                <Route path="/stats">
                    <Logo />
                    <Stats data={params.has('src') ? JSON.parse(atob(params.get('src'))) : null} sharedStats={params.has('src') && params.has('src')} sharedAt={params.has('shared_at') ? parseInt(params.get('shared_at')) : null}/>
                    <Footer />
                </Route>
                <Route path="/faq">
                    <FrequentlyAskedQuestions />
                    <Footer />
                </Route>
                <Route path="/info">
                    <Info />
                    <Footer />
                </Route>
                <Route path="/">
                    <Content
                        hasSlug={hasSlug}
                        onNoThanks={() => setShowActv8(false)}
                        device={deviceSelector}
                        forwardParams={forwardParams}
                        showActv8={showActv8}
                        location={location}
                        catchUrlSearch={catchUrlSearch}
                        setShowError={setShowError}
                        setLoading={setLoading}
                        timestamp={timestamp}
                    />
                </Route>                
            </Switch>
        </Router>
        </div>
    );
};
export default withCookies(withRouter(App));
